import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=5a9c36de"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports